import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MMCustomPaginator from './MMCustomPaginator';
import { format } from 'date-fns';

const dateFormat = (date) => {
  return <span>{format(date, 'dd MMM yyyy')}</span>;
};

const ProductList = ({ config, hasInvestmentCategory }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [latestNavDate, setLatestNavDate] = useState(new Date());
  const [activeTab, setActiveTab] = useState('top');

  useEffect(() => {
    fetchProductData();
  }, [first, rows, sortField, sortOrder, activeTab]);

  const fetchProductData = async () => {
    try {
      setLoading(true);
      const offset = first;
      const limit = rows;
      const sort_by = sortField ? sortField : 'sort_order';
      const sort_order = sortOrder === 1 ? 'asc' : 'desc';
      const criteria = activeTab === 'mm' ? 'mm' : '';
      const response = await axios.get(`${config.PY_API_URL}v2/category/${encodeURIComponent(config.categoryCode)}/products`, {
        params: {
          offset,
          limit,
          sort_by,
          sort_order,
          criteria,
        },
      });

      const { data } = response;
      if (data && data.data && data.data.products) {
        const products = data.data.products;
        const validDates = products.map(product => new Date(product.last_nav_date))
          .filter(date => !isNaN(date) && date != null && date != '');
        const latestDate = validDates.length > 0 ? new Date(Math.max(...validDates)) : new Date();
        setLatestNavDate(latestDate); 
        setProducts(data.data.products);
        setTotalRecords(data.data.total_count);
      } else {
        setProducts([]);
        setTotalRecords(0);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching product data:', error);
      setLoading(false);
    }
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const formattedDate = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(latestNavDate);

  return (
    <div className='mm-product-list'>
      <div className='tabs-container'>
        <span 
          className={activeTab === 'top' ? 'active-tab' : ''} 
          onClick={() => setActiveTab('top')}
        >
          Top Products
        </span>
        <span 
          className={activeTab === 'mm' ? 'active-tab' : ''} 
          onClick={() => setActiveTab('mm')}
        >
          MM Recommended
        </span>
      </div>

      <div>
        {hasInvestmentCategory && 
          <div>
            As on {formattedDate}
          </div>
        }
        <div>
          {products && products.length > 0 ? (
            <div>
              {products.map((fund, index) => (
                <a className='product-card-link' href={`${config.siteUrl}/product-detail/${fund.product_code}`}>
                  <div key={fund.id} className="fund-card row">
                    <div className="fund-logo col-md-1" style={{background: `${fund.icon_bg_color || '#ccc'}`}}>
                      <img src={fund.icon} alt={''}/>
                    </div>
                    <div className='col-md-11'>
                      <div className='row'>
                        <div className="fund-info col-md-12">
                          <h2>{fund.name}</h2>
                          <p>{fund.type}</p>
                        </div>
                        { fund.product_type_code == 1 && (
                          <>
                            <div className="col-md-12">
                              <div className="fund-returns row">
                                <div className='col-md-4'>
                                  <h4>1Y Return:</h4>
                                  <p>{fund.returns_1_years ? `${fund.returns_1_years}%` : 'N/A'}</p>
                                </div>
                                <div className='col-md-4'>
                                  <h4>3Y Return:</h4>
                                  <p>{fund.returns_3_years ? `${fund.returns_3_years}%` : 'N/A'}</p>
                                </div>
                                <div className='col-md-4'>
                                  <h4>5Y Return:</h4>
                                  <p>{fund.returns_5_years ? `${fund.returns_5_years}%` : 'N/A'}</p>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="fund-returns row">
                                <div className='col-md-4'>
                                  <h4>Launch Date:</h4>
                                  <p>{fund.start_date ? dateFormat(fund.start_date) : 'N/A'}</p>
                                </div>
                                <div className='col-md-4'>
                                  <h4>Current NAV:</h4>
                                  <p>{fund.nav ? fund.nav.toFixed(2) : 'N/A'}</p>
                                </div>
                                <div className='col-md-4'>
                                  <h4>AUM:</h4>
                                  <p>{fund.aum ? fund.aum : 'N/A'}</p>
                                </div>
                                <div className='col-md-4'>
                                  <h4>TER:</h4>
                                  <p>{fund.ter ? fund.ter : 'N/A'}</p>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          ) : (
            <>
              <div className='card'>
                <img style={{width:'200px', margin: 'auto', marginTop: '50px', marginBottom: '50px'}} src='https://www.moneymarche.com/wp-content/uploads/2025/02/product_not_found.jpeg'/>
                {/* <p>
                  No products found
                </p> */}
              </div>
            </>
          )}
        </div>
      </div>

      {totalRecords > rows && (
        <MMCustomPaginator
          first={first}
          rows={rows}
          totalRecords={totalRecords}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default ProductList;
